var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrap"},[_c('h1',{style:({'text-align': _vm.align})},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }